import { SiteVideoInline } from "../../../siteWidgets/videoPlayer/genericInlineVideoPlayer/siteVideoInline";
import { SiteVideoData } from "../../../interfaces";
import { useVerticalVideoPlayer } from "../hooks/useVerticalVideoPlayer";
import { useEffect } from "react";

interface VerticalVideoPlayerProps {
    itemId: string;
    index: number;
    media: SiteVideoData;
    isMobile: boolean;
    isGalleryView?: boolean;
    showPrerollAds: boolean;
    hidePrerollAds?: boolean;
    prerollIndex?: number;
    currentPlayingVideo?: number;
    dynamicWidth?: number;
    dynamicHeight?: number;
    onPlayerApiReady?: (playerApiRef: any) => void;
    onNextSlide?: () => void;
    isRylz?: boolean;
}

export const VerticalVideoPlayer = (props: VerticalVideoPlayerProps) => {
    const { itemId, index, media, isMobile, isGalleryView, showPrerollAds, hidePrerollAds,
        prerollIndex, currentPlayingVideo, dynamicWidth, dynamicHeight, onPlayerApiReady, onNextSlide, isRylz } = props;

    const videoPlayer = useVerticalVideoPlayer({
        itemId,
        index,
        media,
        isGalleryView,
        showPrerollAds,
        hidePrerollAds,
        prerollIndex,
        currentPlayingVideo,
        onNextSlide,
        enabled: true,
    });

    useEffect(() => {
        if (onPlayerApiReady && videoPlayer.playerApiRef) {
            onPlayerApiReady(videoPlayer.playerApiRef);
        }
    }, [videoPlayer.playerApiRef]);

    if (!videoPlayer.shouldDisplayVideo || !videoPlayer.playerMedia) return null;

    return (
        <SiteVideoInline
            isRylz={isRylz}
            preload={"auto"}
            isShareButton={false}
            applyStickyness={true}
            adIndex={prerollIndex}
            data={videoPlayer.playerMedia}
            runArticleAutoPlayLogic={false}
            key={videoPlayer.playerMountKey}
            width={isMobile ? null : dynamicWidth}
            height={isMobile ? null : dynamicHeight}
            onPlayerLoaded={videoPlayer.onPlayerLoaded}
            onVideoEnded={videoPlayer.handleVideoEnded}
            hideVideoAds={showPrerollAds ? hidePrerollAds : true}
        />
    );
};
